var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duplicate-container"},[_c('div',{ref:"clone",staticClass:"duplicate"},[_vm._t("default")],2),_c('div',{staticClass:"actions"},[_vm._v("add website")])])
}
var staticRenderFns = []

export { render, staticRenderFns }